import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";

import { listTiersQueryKey } from "../createTier/mutation";

export function useDeleteTierMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, number>({
    mutationFn: async (id) => {
      await api.delete(`/v1/partner_tier_admin/${id}/`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listTiersQueryKey, refetchType: "all" });
      open?.({ type: "success", message: translate("v1/partner_tier_admin.success.delete") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
